<app-page-centered-content>
    <app-sign-in></app-sign-in>
</app-page-centered-content>
